/**
 * Branded integer ID types for type-safe entity references.
 *
 * These prevent accidentally passing a PatientId where a VisitId is expected.
 * IDs are plain numbers at runtime, but TypeScript enforces the brand at compile time.
 *
 * Usage:
 *   const patientId = 42 as PatientId;
 *   function getPatient(id: PatientId): Promise<Patient> { ... }
 *   getPatient(patientId);  // OK
 *   getPatient(42 as VisitId);  // Compile error!
 */
// ─── Utility: wrap raw number as branded ID ───────────────
/**
 * Cast a raw number to a branded ID type.
 * Use sparingly — only at system boundaries (DB results, API params).
 *
 * Example:
 *   const id = brandId<PatientId>(row.id);
 */
export function brandId(raw) {
    return raw;
}
/**
 * Extract the raw number from a branded ID.
 * Use when passing to external systems that don't understand brands.
 *
 * Example:
 *   const raw = unwrapId(patientId); // number
 */
export function unwrapId(id) {
    return id;
}
//# sourceMappingURL=ids.js.map